import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { GraphqlFilterRoot } from "../root/general/crudGraphql/domain/models/graphqlModel";
import { crudExport } from "../root/general/infrastructure/slices/crudTableSlice/crudTableSlice";
import { useAppDispatch } from "./useTypedSelector";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

export const useCrudExport = ({
  pageCount,
  queryFunction,
  queryData,
  filters,
}: {
  pageCount?: number;
  queryFunction: string;
  queryData: (string | { [key: string]: string | unknown[] })[];
  filters?: GraphqlFilterRoot;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");

  const exportData = useCallback(() => {
    setIsLoading(true);
    dispatch(
      crudExport({
        queryFunction,
        queryData,
        filters,
      }),
    )
      .then((res) => {
        const response = res.payload as {
          url: string;
          filename: string;
          mimeType: string;
        };

        if (response?.url) {
          const link = document.createElement("a");
          link.href = response.url;
          link.download = response.filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch, queryFunction, queryData, filters]);

  return {
    exportButton: (
      <>
        {pageCount !== undefined && pageCount > 100 ? (
          <OverlayTrigger
            overlay={
              <Tooltip className="custom-tooltip">
                {t(
                  "The maximum to export is 100 pages, please use the filters first",
                )}
              </Tooltip>
            }
          >
            <span>
              <Button size="sm" className={"responsive-button ms-3"} disabled>
                {t("Export")}
              </Button>
            </span>
          </OverlayTrigger>
        ) : (
          <Button
            size="sm"
            className={"responsive-button ms-3"}
            onClick={exportData}
            disabled={isLoading || (pageCount !== undefined && pageCount > 100)}
          >
            {isLoading ? <Spinner animation="border" size="sm" /> : ""}{" "}
            {t("Export")}
          </Button>
        )}
      </>
    ),
  };
};
